var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import ResetButton from "../../components/ResetButton";
import { Form, TextInput, TextInputWidth } from "@eightfold.ai/octuple";
import FormRequired from "../../components/FormRequired";
import { useClient } from "../../hooks/client";
import { useGetDataFiltersQuery, useGetLookupsFiltersQuery, useGetNineBox, } from "../../store/api/core";
import styles from "../../components/TalentReview/TalentReview.module.scss";
import NineBoxErrorMessage from "../../components/TalentReview/NineBoxErrorMessage";
import { EditableNineBoxSelections, useEditableSelectionsMethods, } from "../../components/TalentReview/TalentReview";
export var EditNineBoxForm = function (_a) {
    var _b, _c;
    var initialValue = _a.initialValue, boxId = _a.boxId, setFormError = _a.setFormError, setErrorClass = _a.setErrorClass, onFormFinish = _a.onFormFinish, isReadOnly = _a.isReadOnly, getData = _a.getData, openConfirmDialog = _a.openConfirmDialog, form = _a.form, field = _a.field, errorClass = _a.errorClass, formError = _a.formError, resetEditFormValues = _a.resetEditFormValues, compareBoxName = _a.compareBoxName, changeDisableButtonStatus = _a.changeDisableButtonStatus;
    var initialValues = {
        name: initialValue,
    };
    var client = useClient();
    var data = useGetDataFiltersQuery({ clientId: client.clientId });
    var lookupData = useGetLookupsFiltersQuery({ clientId: client.clientId });
    var nineBoxDetails = useGetNineBox({ id: boxId });
    var dataFilters = (_b = nineBoxDetails === null || nineBoxDetails === void 0 ? void 0 : nineBoxDetails.data) === null || _b === void 0 ? void 0 : _b.data;
    var _d = useState({
        business: [],
        location1: [],
        location2: [],
        division: [],
        function: [],
        subFunction: [],
        role: [],
        level: [],
        manager: [],
    }), selections = _d[0], setSelections = _d[1];
    React.useEffect(function () { return function () {
        var _a;
        var style = __assign({}, (((_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.style) || {}));
        delete style.overflow;
        setTimeout(function () {
            document.querySelector("body").style = style;
        }, 0);
    }; }, []);
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (dataFilters && ((_b = (_a = lookupData === null || lookupData === void 0 ? void 0 : lookupData.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.function)) {
            var obj = {
                business: mapToLabelValue(dataFilters.filters.businessUnits),
                location1: mapToLabelValue(dataFilters.filters.locations),
                location2: mapToLabelValue(dataFilters.filters.locationCountries),
                division: mapToLabelValue(dataFilters.filters.divisions),
                function: mapToLabelValue(dataFilters.filters.functions, (_c = lookupData.data) === null || _c === void 0 ? void 0 : _c.data.function),
                subFunction: mapToLabelValue(dataFilters.filters.subFunctions, (_d = lookupData.data) === null || _d === void 0 ? void 0 : _d.data.sub_function),
                role: mapToLabelValue(dataFilters.filters.roles, (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.roles),
                level: mapToLabelValue(dataFilters.filters.levels, (_g = lookupData.data) === null || _g === void 0 ? void 0 : _g.data.level),
                manager: mapToLabelValue(dataFilters.filters.managers),
            };
            if (obj) {
                setSelections(obj);
            }
            setRerenderKey(Math.random());
        }
    }, [(_c = lookupData === null || lookupData === void 0 ? void 0 : lookupData.data) === null || _c === void 0 ? void 0 : _c.data]);
    React.useEffect(function () {
        return function () {
            resetEditFormValues();
        };
    }, []);
    var _e = useState(Math.random()), rerenderKey = _e[0], setRerenderKey = _e[1];
    var _f = useEditableSelectionsMethods({
        selections: selections,
        setSelections: setSelections,
        setRerenderKey: setRerenderKey,
        disableSave: changeDisableButtonStatus,
    }), handleReset = _f.handleReset, leaderCount = _f.leaderCount;
    var mapToLabelValue = function (items, labelObjects) {
        if (Array.isArray(labelObjects)) {
            var arrayValues = labelObjects.filter(function (label) {
                return items === null || items === void 0 ? void 0 : items.some(function (item) { return item == label.value; });
            });
            return arrayValues;
        }
        else {
            return (items === null || items === void 0 ? void 0 : items.map(function (item) { return ({ label: item, value: item }); })) || [];
        }
    };
    var handleFormFinish = function (formValues) {
        if (isReadOnly) {
            onFormFinish(formValues, selections);
            setFormError("");
            setErrorClass("");
        }
        else if (getData) {
            getData({ name: formValues.name, filters: selections });
            if (openConfirmDialog) {
                openConfirmDialog();
                setFormError("");
                setErrorClass("");
            }
        }
    };
    var boxNameRules = [
        { required: true, message: "9 Box name is required" },
        {
            type: "string",
            max: 30,
            message: "9 Box name cannot be more than ${max} characters",
        },
    ];
    var versionNameRules = [
        { required: true, message: "Version name is required" },
    ];
    return (_jsxs("div", __assign({ "data-testid": "nineboxform" }, { children: [_jsx(FormRequired, {}), _jsxs(Form, __assign({ form: form, layout: "vertical", autoComplete: "off", onFinish: handleFormFinish, initialValues: initialValues }, { children: [_jsx(Form.Item, __assign({ label: "Name", name: "name", rules: field == "boxName" ? boxNameRules : versionNameRules, style: { marginBottom: "12px" } }, { children: _jsx(TextInput, { inputWidth: TextInputWidth.fill, classNames: errorClass, onChange: function () { return compareBoxName(); } }) })), _jsx(EditableNineBoxSelections, { isReadOnly: isReadOnly, selections: selections, setSelections: setSelections }), _jsx("div", __assign({ role: "alert", className: "form-item-explain-error ".concat(errorClass) }, { children: formError })), leaderCount == undefined
                        ? ""
                        : leaderCount <= 1 && _jsx(NineBoxErrorMessage, {})] }), rerenderKey), _jsxs("div", __assign({ className: styles.resetButtonWrapper }, { children: [_jsx(ResetButton, { label: "Reset Filters", onClick: handleReset }), _jsx("div", __assign({ className: styles.filteredLeaderCount }, { children: "".concat(leaderCount ? leaderCount : 0, " ").concat(leaderCount == 1 ? "Leader" : "Leaders") }))] }))] })));
};
export default EditNineBoxForm;
